import * as React from 'react';
import identity from 'lodash/identity';
import { useCombinedRefs, useEventListener } from '@ovpn-ui/utils';
function ClickAwayListener({
  onClickAway,
  children,
  getEl = identity
}) {
  const movedRef = React.useRef(false);
  const innerRef = React.useRef(null);
  const combinedRef = useCombinedRefs(children == null ? void 0 : children.ref, innerRef);
  const handleClickAway = React.useCallback(e => {
    const el = innerRef.current && getEl(innerRef.current);
    if (!el || el.contains(e.target)) return;
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    onClickAway == null ? void 0 : onClickAway(e);
  }, [onClickAway, getEl]);
  const handleTouchMove = React.useCallback(() => {
    movedRef.current = true;
  }, []);
  useEventListener('touchend', handleClickAway);
  useEventListener('mousedown', handleClickAway);
  useEventListener('touchmove', handleTouchMove);
  return children ? /*#__PURE__*/React.cloneElement(children, {
    ref: combinedRef
  }) : null;
}
export default ClickAwayListener;